import {
    Box,
    Link,
    Skeleton,
    ToggleButton,
    ToggleButtonGroup,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Link as RouterLink } from 'react-router-dom';
import { S } from './strings';
import { bankLabel, indicatorName, type BankInfo } from './types';
import {
    PageHeader,
    PageMeta,
} from '../../../components/common/page/PageHeader';

interface PiprHeaderProps {
    bank: string;
    banks: readonly BankInfo[];
    onBank: (bank: string) => void;
}

export function PiprHeader({ bank, banks, onBank }: PiprHeaderProps) {
    const info = banks.find(b => b.bank === bank) ?? null;
    return (
        <Box>
            <Link
                component={RouterLink}
                to="/monitor"
                underline="hover"
                color="text.secondary"
                sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 0.5,
                    fontSize: '12px',
                    mb: 0.5,
                }}
            >
                <ArrowBackIcon sx={{ fontSize: 14 }} />
                Monitor
            </Link>
            <PageHeader
                wrap
                title={indicatorName(bank)}
                meta={
                    <>
                        <PageMeta>{S.heading}</PageMeta>
                        {info ? (
                            <>
                                <PageMeta>{info.name}</PageMeta>
                                <PageMeta>{info.rateName}</PageMeta>
                            </>
                        ) : (
                            <Skeleton variant="text" width={220} />
                        )}
                    </>
                }
            >
                {banks.length > 1 && (
                    <ToggleButtonGroup
                        size="small"
                        exclusive
                        value={bank}
                        aria-label="Select central bank"
                        onChange={(_, value: string | null) => {
                            if (value) onBank(value);
                        }}
                        sx={{
                            height: 28,
                            '& .MuiToggleButton-root': {
                                py: '2px',
                                px: 1.25,
                                fontSize: '12px',
                                fontWeight: 600,
                                textTransform: 'none',
                                borderColor: 'divider',
                            },
                        }}
                    >
                        {banks.map(b => {
                            const label = bankLabel(b.bank);
                            return (
                                <ToggleButton key={b.bank} value={b.bank}>
                                    {label.symbol && (
                                        <Box component="span" sx={{ mr: 0.6 }}>
                                            {label.symbol}
                                        </Box>
                                    )}
                                    {label.code}
                                </ToggleButton>
                            );
                        })}
                    </ToggleButtonGroup>
                )}
            </PageHeader>
        </Box>
    );
}
